import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BellRing, ClipboardCheck } from "lucide-react";
import { toast } from "sonner";
import { dismissReminder, getDueReminders, getTracker } from "../../lib/api";
import { useVisiblePolling } from "../../lib/usePolling";

// Main dashboard: Tracker summary + due Reminders (both live, 5s polling while visible).
export function DashboardTracker() {
  const [t, setT] = useState(null);
  const [rem, setRem] = useState([]);
  const load = useCallback(() => {
    getTracker().then(setT).catch(() => {});
    getDueReminders().then((d) => setRem(d.items || [])).catch(() => {});
  }, []);
  useVisiblePolling(load, 5000);

  const dismiss = async (id) => {
    try { await dismissReminder(id); setRem((r) => r.filter((x) => x.id !== id)); toast.success("Reminder dismissed"); }
    catch { toast.error("Couldn't dismiss the reminder"); }
  };

  return (
    <>
      <section className="surface-card mt-10 p-6 md:p-8" data-testid="dashboard-tracker">
        <div className="label-eyebrow flex items-center gap-3"><ClipboardCheck size={14} strokeWidth={1.8} /> Weekly Check In Action Tracker</div>
        <div className="mt-3 flex items-end justify-between gap-4 flex-wrap">
          <p className="font-serif text-2xl md:text-3xl text-brand-ink" data-testid="dashboard-items-to-review">
            {t ? <><strong>{t.items_to_review}</strong> Items to Review for week of {t.cycle.label}</> : "Loading…"}
          </p>
          <Link to="/coach/tracker" className="btn-primary inline-flex items-center gap-2" data-testid="see-tracker-btn">See Tracker <ArrowRight size={16} /></Link>
        </div>
      </section>
      <section className="mt-8" data-testid="dashboard-reminders">
        <div className="label-eyebrow flex items-center gap-3"><BellRing size={14} strokeWidth={1.8} /> Reminders</div>
        {rem.length === 0 ? (
          <p className="mt-3 text-sm text-brand-ink-muted" data-testid="reminders-empty">No reminders due.</p>
        ) : (
          <div className="mt-3 space-y-3">
            {rem.map((r) => (
              <div key={r.id} className="surface-card p-5 flex items-start justify-between gap-4" data-testid={`due-reminder-${r.id}`}>
                <div>
                  <div className="font-semibold text-brand-ink" data-testid={`due-reminder-name-${r.id}`}>Reminder for {r.full_name}</div>
                  <p className="mt-1 text-brand-ink whitespace-pre-wrap" data-testid={`due-reminder-text-${r.id}`}>{r.text}</p>
                  <p className="mt-1 text-xs text-brand-ink-muted" data-testid={`due-reminder-when-${r.id}`}>
                    {new Date(`${r.due_date}T00:00:00Z`).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" })} · {r.due_time}
                    {r.overdue && <span className="ml-2 text-red-700 font-bold uppercase tracking-[0.15em]" data-testid={`due-reminder-overdue-${r.id}`}>Overdue</span>}
                  </p>
                </div>
                <button type="button" onClick={() => dismiss(r.id)} className="btn-ghost border border-brand-border rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold" data-testid={`dismiss-reminder-${r.id}`}>Dismiss</button>
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}

export default DashboardTracker;
